export function renderEmptyState(root: HTMLElement) {
  root.innerHTML = `
    <div class="empty">
      <p class="muted">No transactions yet.</p>
      <p class="muted">Type something like <code>380 spinneys</code> above to log your first one.</p>
    </div>
  `;
}
